import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-external-redirect',
    template: '<p>Redirigiendo...</p>',
    standalone: false
})
export class ExternalRedirectComponent implements OnInit {
  ngOnInit() {
    window.location.href = environment.apiBaseUrl;
  }
}
